(() => {
  angular
    .module('app.core')
    .factory('OnboardingService', onboardingService);

  onboardingService.$inject = ['$resource', 'ModalService'];

  function onboardingService($resource, ModalService) {
    const onboardingResource = $resource('/onboarding/');

    onboardingService.getLatest = () => onboardingResource.get().$promise;
    onboardingService.displayLatest = () => {
      onboardingService.getLatest().then(({ data }) => {
        openModal(data.id);
      });
    };

    function openModal(templateName) {
      ModalService
        .showModal({
          templateUrl: '../../assets/js/app/core/onboarding/templates/' + templateName + '.html?v=0',
          controller: () => {
            return {
              onClose: () => {
                localStorage.setItem('showOnboarding', new Date());
              },
            };
          },
          controllerAs: 'onboardingService',
        })
        .then(modal => {
          modal.element.modal();
          modal.close.then(result => { });
        });
    }

    return onboardingService;
  }
})();
